import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Dialog from '@mui/material/Dialog';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import DocManagementService from '../documentUpload/service/DocManagementService';
import { EditMetaDataProps } from './types';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

const MetricsDetails: FC<any> = ({ expanded, accordionInfo, handleToogleAccordion }: EditMetaDataProps) => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const { preferedDateFormat } = usePreferedDateFormat();
  const docService = new DocManagementService();
  const dispatch = useDispatch();
  function createData(name: string, value: string | null) {
    return { name, value };
  }
  const dateString = documentDetail?.data[0]?.isf_doc_date;
  const date = preferedDateFormat(dateString);
  const isfLevel = documentDetail?.data[0]?.isf_doc_level;
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const entity = documentDetail?.data[0]?.isf_document_name;

  const data = {
    query_filters: [
      {
        name: 'isf_document_id',
        value: documentDetail?.data[0]?.isf_document_id,
        operation: 'equals'
      }
    ],
    filter_types: ['All']
  };

  const update = async () => {
    const res = await docService.getSearchResult(
      data,
      selectedStudy,
      selectedCountry,
      selectedSite,
      isfLevel,
      selectedStudy === '--' ? false : true,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      entity
    );
    setDocumentDetail(dispatch, [
      {
        ...documentDetail.data[0],
        isf_doc_viewer_approval_cycle: res?.data?.selected_data[0]?.document_data.isf_doc_viewer_approval_cycle,
        isf_doc_approval_date: res?.data?.selected_data[0]?.document_data.isf_doc_approval_date,
        isf_doc_approval_st_dt: res?.data?.selected_data[0]?.document_data.isf_doc_approval_st_dt
      }
    ]);
  };

  useEffect(() => {
    update();
  }, [expanded]);

  const rows = [
    createData(
      'Approval Complete Date:',
      documentDetail.data[0] && preferedDateFormat(documentDetail.data[0]?.isf_doc_approval_date)
    ),
    createData(
      'Approval  Start Date:',
      documentDetail.data[0] && preferedDateFormat(documentDetail.data[0]?.isf_doc_approval_st_dt)
    ),
    createData(
      'No of Approval Cycle:',
      documentDetail.data[0] && documentDetail.data[0]?.isf_doc_viewer_approval_cycle
    ),
    createData(
      'Upload Date:',
      documentDetail.data[0] && preferedDateFormat(documentDetail.data[0]?.isf_doc_upload_date)
    )
  ];

  return (
    <>
      <Accordion
        expanded={accordionInfo.position === expanded}
        onChange={handleToogleAccordion(accordionInfo.position)}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
          <Typography sx={{ width: '60%', flexShrink: 0 }} className="acc-header">
            Metrics
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableBody>
                  {rows?.map(row => (
                    <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell align="right">{row.value}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default MetricsDetails;
